/**
 * ScopedModal - Portal-based modal scoped to player detail content area
 *
 * Exports ScopedModalView directly since no container logic is needed.
 * The modal renders via @gorhom/portal into the player page content area.
 */

export { default } from "./ScopedModalView";
